import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <SectionWrapper narrow data-id="element-61">
      <div className="border border-border-custom p-8 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-6 bg-white/50" data-id="element-62">
        <div className="flex-shrink-0" data-id="element-63">
          <ShieldCheck className="w-12 h-12 text-sage" strokeWidth={1.5} data-id="element-64" />
        </div>
        <div className="text-center md:text-left" data-id="element-65">
          <h3 className="text-2xl font-serif text-text mb-3" data-id="element-66">
            Garantía Blindaje 7 Días
          </h3>
          <p className="text-text-secondary leading-relaxed" data-id="element-67">
            Si sentís que este sistema no te aporta la claridad y estructura que
            buscás, te devolvemos el 100% de tu inversión. Sin preguntas
            incómodas. Queremos que tu decisión sea tan tranquila como el
            resultado que buscás.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}